export type TimesheetStatus = 'draft' | 'submitted' | 'approved' | 'rejected';

/**
 * One grid row — a work type inside a project.
 * Maps to the leaf ActivityType; the project/client above it come from the type's parents.
 */
export interface TimesheetRow {
  id: string;
  clientName: string;
  projectName: string;
  /** Colour of the project group, mirrors ActivityType.color */
  projectColor: string;
  workType: string;
  billable: boolean;
  /** Pushed by the organization — the project itself is read-only for the employee */
  fromOrg: boolean;
  /** Hours per day, Monday first */
  hours: number[];
}

/** A project/work type the organization offers but which is not on the sheet yet. */
export type AvailableRow = Omit<TimesheetRow, 'hours'>;

export interface Timesheet {
  status: TimesheetStatus;
  /** Who reviews (or reviewed) the sheet */
  reviewer?: string;
  reviewedOn?: string;
  /** Set when the manager sends the sheet back */
  rejectionNote?: string;
  rows: TimesheetRow[];
}

export const WEEK_TARGET_HOURS = 40;
